import React from 'react';
import { connect } from 'react-redux';
import EnumSelectorBase from './EnumSelectorBase';

const PointTypeSelector = ({ pointTypes, value, setValue, sortOptions, renderOption }) => {
  let renderValue = value;
  if (Number.isInteger(value)) {
    // base case support for the caller not being pointType aware
    renderValue = pointTypes[value];
  }

  return (
    <EnumSelectorBase
      name="Point Type"
      options={Object.values(pointTypes).sort(sortOptions)}
      getOptionLabel={(type) => type?.name || ''}
      isOptionEqualToValue={(option, v) => option.name === v}
      value={renderValue}
      onChange={setValue}
      renderOption={renderOption}
    />
  );
};

export default connect(
  ({
    entities: {
      pointTypes: { byId: pointTypes },
    },
  }) => ({
    pointTypes,
  })
)(PointTypeSelector);
